import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <div className="navbar fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-lg shadow-md h-16">
      <div className="navbar-start">
        <Link to="/" className="text-xl font-black ml-6 lg:text-3xl lg:ml-8">Vivek <span className="font-light text-orange-500">|</span> Agarwal</Link>
      </div>
      <div className="navbar-end hidden lg:flex">
        <ul className="menu text-base font-light menu-horizontal px-1 mr-4 lg:mr-8">
          <li><a href="/#home" className="hover:font-bold hover:border-b-2 hover:border-orange-500 hover:rounded-none transition-border duration-300 ease-in-out px-4 py-2">Home</a></li>
          <li><Link to="/work" className="hover:font-bold hover:border-b-2 hover:border-orange-500 hover:rounded-none transition-border duration-300 ease-in-out px-4 py-2">Work</Link></li>
          <li><Link to="/get-in-touch" className=" hover:font-extrabold hover:border-b-2 hover:border-orange-500 hover:rounded-none transition-border duration-300 ease-in-out px-4 py-2">Get in Touch</Link></li>
        </ul>
      </div>
      <div className="navbar-end lg:hidden">
        <div className="dropdown dropdown-end mr-8">
          <div tabIndex={0} role="button" className="btn btn-ghost hover:bg-orange-500 hover:text-white transition-all duration-200 rounded-full mr-4">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16"></path>
            </svg>
          </div>
          <ul tabIndex={0} className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-white rounded-box w-52">
            <li><a href="/#home" className="hover:bg-orange-500 hover:text-white transition-all duration-200 rounded-lg">Home</a></li>
            <li><Link to="/work" className="hover:bg-orange-500 hover:text-white transition-all duration-200 rounded-lg">Work</Link></li>
            <li><Link to="/get-in-touch" className="hover:bg-orange-500 hover:text-white transition-all duration-200 rounded-lg">Get in Touch</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar; 